/**
 * Dependencies
 */

import { styled } from '@material-ui/styles';

/**
 * Define style
 */

const MediatorCasesShowStyle = styled('div')({
  margin: '85px 40px',
  ".pendingTabActive": {
    backgroundColor: "#000"
  }
});

/**
 * Export style
 */

export default MediatorCasesShowStyle;
